<div
  class="one-call"
  [disableTooltip]="disabled"
  [ngbTooltip]="'productDetails.labelOneCall' | transloco"
  [tooltipClass]="'ngb-boels-tooltip'"
  [placement]="tooltipPlacement + ' auto'"
  [autoClose]="'inside'"
  tabindex="0"
  role="button"
>
  <fa-icon [icon]="faPhone"></fa-icon>
  <span>{{ 'productDetails.labelOneCallIcon' | transloco }}</span>
</div>
